import React from 'react';

import { BoxDefaultProps, BoxPropTypes } from 'src/components/Box/propTypes';
import s from './Box.styles';

const Box = ({
  active,
  children,
  fullwidth,
  fullwidth2,
  left,
  leftColProps,
  right,
  rightColProps,
  stickyContainer,
  ...rest
}) => {
  const halfWidth = !!left && !right && !children;
  return (
    <s.Box
      active={active}
      fullwidth={fullwidth}
      halfWidth={halfWidth && !fullwidth && !fullwidth2}
      stickyContainer={stickyContainer}
      {...rest}
      >
      {left && (
        <s.BoxCol {...leftColProps} isInlineBlock={!!stickyContainer}>
          {left}
        </s.BoxCol>
      )}
      {right && (
        <s.BoxCol {...rightColProps} isInlineBlock={!!stickyContainer}>
          {right}
        </s.BoxCol>
      )}
      {children && (
        <s.BoxCol>
          {children}
        </s.BoxCol>
      )}
    </s.Box>
  );
};

Box.propTypes = BoxPropTypes;
Box.defaultProps = BoxDefaultProps;

export default React.memo(Box);
